import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import config from "@/config";
import useGetSearchParams from "@/hooks/useGetSearchParams";
import useQuery from "@/hooks/useQuery";
import HomeHeader from '@/shared-components/home/components/HomeHeader';
import Loader from '@/shared-components/loader/Loader';  // ✅ Correct Loader import
import Text from "@/shared-components/text/components/Text";
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';

import VirtualList from "./components/VirtualList";

import './index.css';

export default function HomeArtlists({ fromSearch = false, valueFromSearch = ""  }) {
  const [params, setParams] = useGetSearchParams();
  const [query, setQuery] = useState(params || { q: "" });  // ✅ Simplified the ternary

  const { loading, queryData, loadMoreData } = useQuery(
    "home_artlists", 
    `${config.apis.api.url}/search/artlist`, 
    query, 
    {
      invalidateWhen: ["NEW_ARTLIST", "EDIT_ARTLIST", "DELETE_ARTLIST"],
      injectToken: true,
    }
  );

  function onInput(value) {
    const newQuery = { q: value };
    setQuery(newQuery);
    setParams(newQuery, { replace: true });
  }

  useEffect(() => {
    onInput(valueFromSearch.q);
  }, [valueFromSearch.q]);

  return (
    <>
      { !fromSearch &&
        <div>
          <Helmet>
            <title>Artlists | Suarte</title>
            <meta
              name="description"
              content="Create, curate, and share your own lists of artworks in Suarte. Discover the play mode and enjoy your curated pieces at any moment on any screen."
            />
            <link rel="canonical" href={"https://suarte.art/artlists"} />
          </Helmet>
          <AppNavigationPage>
            <div className="home-artlists__page">
              <HomeHeader 
                onInput={onInput} 
                value={query.q} 
                icon={<ArtlistIcon className="home-artlists__header-icon" />} 
                text="Artlists" 
                placeholder="Search for artlists..."
              />

              {/* ✅ Simplified conditional rendering */}
              {loading ? (
                <Loader />
              ) : queryData?.data?.data?.length === 0 ? (
                <Text className="home-artlists__empty-text" paragraph medium>
              No artlists available for your search query.
                </Text>
              ) : (
                <VirtualList 
                  key={queryData?.queryString} 
                  items={queryData?.data} 
                  onLoadMore={loadMoreData}
                />
              )}
            </div>
          </AppNavigationPage>
        </div>
      }
      { fromSearch &&
        <>
          {
            loading ? 
              <Loader/>
              : queryData.data.data.length === 0 ?
                <Text className="home-artlists__empty-text" paragraph medium>
                  No artlists available for your search query.
                </Text>
                :
                <VirtualList 
                  key={queryData.queryString} 
                  items={queryData.data} 
                  onLoadMore={loadMoreData}
                  fromSearch={fromSearch}
                />
          }
        </>
      }
    </>
  );
}
